module.exports = __webpack_public_path__ + "static/media/phone-past.bd3d20f7.svg";